// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CPSy1","colMin":"styles_colMin__An0b2"};